import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ProgressAllocationActionItem } from '../../../models/progress-allocation-action-item';
import { ProgressAllocationService } from '../../../services/progress/progress-allocation.service';
import { Subscription } from 'rxjs';
import { SettingsService } from '../../../services/settings/settings.service';
import { RouterLink } from '@angular/router';
import { MatProgressBar } from '@angular/material/progress-bar';
import { DecimalPipe, PercentPipe } from '@angular/common';

@Component({
    selector: 'app-progress-allocation-preferred-action',
    templateUrl: './progress-allocation-preferred-action.component.html',
    styleUrls: ['./progress-allocation-preferred-action.component.scss'],
    imports: [RouterLink, MatProgressBar, DecimalPipe, PercentPipe]
})
export class ProgressAllocationPreferredActionComponent implements OnInit, OnDestroy {

  @Input() expanded = false;

  actionItems: ProgressAllocationActionItem[] | null = null;
  serviceYear = 0;

  closedTotal = 0;
  openTotal = 0;
  pendingTotal = 0;
  grandTotal = 0;

  subs: Subscription[] = [];

  constructor(
    private allocationService: ProgressAllocationService,
    private settingsService: SettingsService) { 
    //TODO
  }

  ngOnInit(): void {
    this.subs.push(this.settingsService.serviceYear.subscribe(result => {
      if(!result) {
        return;
      }

      this.serviceYear = result;
      this.updateData();
    }));

    this.subs.push(this.allocationService.preferredActions.subscribe(result => {
      if(!result) {
        return;
      }

      this.actionItems = result;
      this.getTotals();
    }));
  }

  ngOnDestroy(): void {
    this.subs.forEach(s => s.unsubscribe());
  }

  updateData() {
    this.allocationService.getPreferredActionItems(this.serviceYear);
  }

  getTotals() {
    this.closedTotal = 0;
    this.openTotal = 0;
    this.pendingTotal = 0;
    this.grandTotal = 0;
    
    if (this.actionItems) {
      this.actionItems.forEach(i => {
        this.closedTotal += i.Closed;
        this.openTotal += i.Open;
        this.pendingTotal += i.Pending;
        this.grandTotal += i.Total;
      });
    }
  }

  getLabel(name: string) {
    if(name == 'Supplemental Feed') {
      return 'Supp Feed';
    }

    return name;
  }

}
